import React from 'react'
import BaseComponent from './components/BaseComponent'
import { withRouter, Switch, Route } from 'react-router-dom'
import { CSSTransition, TransitionGroup } from 'react-transition-group'
import _ from 'lodash'
import Header from './components/Header'
import ErrorPage from './components/ErrorPage'
import ArticlePage from './components/ArticlePage'
import HomePage from './components/HomePage'
import BlogPage from './components/BlogPage'
import ReviewsPage from './components/ReviewsPage'
import ContactPage from './components/ContactPage'
import RealizationsPage from './components/RealizationsPage'
import OfferPage from './components/OfferPage'
import GalleryPage from './components/GalleryPage'
import GalleryNewPage from './components/GalleryNewPage'
import AlbumPage from './components/AlbumPage'
import ProductPage from './components/ProductPage'
import SpecialPage from './components/SpecialPage'
import SingleSpecialPage from './components/SingleSpecialPage'
import GenericPage from './components/GenericPage'
import '../style.css'

class MainView extends BaseComponent {

  constructor(props) {
    super(props)
    this.state = { screen : { width: window.innerWidth, height: window.innerHeight }}
    this._bind('disableSelection')
  }

  disableSelection(target){
    window.addEventListener("contextmenu", function(e) { e.preventDefault(); })
   if (typeof target.onselectstart!=="undefined") //For IE 
        target.onselectstart=function(){return false}
   else if (typeof target.style.MozUserSelect!=="undefined") //For Firefox
        target.style.MozUserSelect="none"
   else //All other route (For Opera)
        target.onmousedown=function(){return false}
   target.style.cursor = "default";
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize.bind(this))
    if (typeof window.ga === 'function') {
      window.ga('set', 'page', this.props.location.pathname + this.props.location.search);
      window.ga('send', 'pageview');
    }
    this.disableSelection(document.body)
  }

  scrollTop() {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.location !== this.props.location) {
      setTimeout(this.scrollTop, 400)
      if (typeof window.ga === 'function') {
        window.ga('set', 'page', nextProps.location.pathname + nextProps.location.search);
        window.ga('send', 'pageview');
      }
    }
  }

  handleResize(e) {
    this.setState({ screen : { width: window.innerWidth, height: window.innerHeight }})
  }

  render() {

    let pages = _.filter(this.props.data.pages, { template: "generic" }) 

    let genericPages = pages.map((item, i) => {
      return (
        <Route key={ i } path={ item.slug } exact render={(props) => (<GenericPage data={ this.props.data } screen={ this.state.screen } location={ this.props.location } {...props}/>)}/>
      )
    })

    return (
      <div className="app-inner">
        <Header data={ this.props.data }/>
        <div className="social-side">
          <ul className="social">
            <li><a href={ this.props.data.settings[0].fb } target="_blank" rel="noopener noreferrer"><img src="/assets/img/fb-f.png" alt="Ikona Facebook"/></a></li>
            <li><a href={ this.props.data.settings[0].insta } target="_blank" rel="noopener noreferrer"><img src="/assets/img/in-f.png" alt="Ikona Instagram"/></a></li>
            <li><a href={ this.props.data.settings[0].yt } target="_blank" rel="noopener noreferrer"><img src="/assets/img/yt-f.png" alt="Ikona Youtube"/></a></li>
          </ul>
        </div>
        <TransitionGroup>
          <CSSTransition key={ this.props.location.pathname } classNames="page" timeout={{ enter: 1000, exit: 500 }} >
            <Switch location={ this.props.location }>
              <Route  path="/" exact render={(props) => (<HomePage data={ this.props.data } screen={ this.state.screen } location={ this.props.location } />)}/>
              <Route  path="/oferta" exact render={(props) => (<OfferPage data={ this.props.data } screen={ this.state.screen } location={ this.props.location } {...props}/>)}/>
              <Route  path="/oferta/:name" exact render={(props) => (<OfferPage data={ this.props.data } screen={ this.state.screen } location={ this.props.location } {...props} />)}/>
              <Route  path="/produkt/:name" exact render={(props) => (<ProductPage data={ this.props.data } screen={ this.state.screen } location={ this.props.location } {...props}/>)}/>
              <Route  path="/porady" exact render={(props) => (<BlogPage data={ this.props.data } screen={ this.state.screen } location={ this.props.location } {...props}/>)}/>
              <Route  path="/porady/:page" exact render={(props) => (<BlogPage data={ this.props.data } screen={ this.state.screen } location={ this.props.location } {...props}/>)}/>
              <Route  path="/porady/artykul/:name" exact render={(props) => (<ArticlePage data={ this.props.data } screen={ this.state.screen } location={ this.props.location } {...props}/>)}/>
              <Route  path="/realizacje" exact render={(props) => (<RealizationsPage data={ this.props.data } screen={ this.state.screen } location={ this.props.location } />)}/>
              <Route  path="/realizacje/galeria/:name" exact render={(props) => (<GalleryPage data={ this.props.data } screen={ this.state.screen } location={ this.props.location } {...props}/>)}/>
              <Route  path="/galeria" exact render={(props) => (<GalleryNewPage data={ this.props.data } screen={ this.state.screen } location={ this.props.location } />)}/>
              <Route  path="/galeria/album/:name" exact render={(props) => (<AlbumPage data={ this.props.data } screen={ this.state.screen } location={ this.props.location } {...props}/>)}/>
              <Route  path="/promocje" exact render={(props) => (<SpecialPage data={ this.props.data } screen={ this.state.screen } location={ this.props.location } {...props}/>)}/>
              <Route  path="/promocja/:name" exact render={(props) => (<SingleSpecialPage data={ this.props.data } screen={ this.state.screen } location={ this.props.location } {...props}/>)}/>
              <Route  path="/opinie" exact render={(props) => (<ReviewsPage data={ this.props.data } screen={ this.state.screen } location={ this.props.location } {...props}/>)}/>
              <Route  path="/opinie/:page" exact render={(props) => (<ReviewsPage data={ this.props.data } screen={ this.state.screen } location={ this.props.location } {...props}/>)}/>
              <Route  path="/kontakt" exact render={(props) => (<ContactPage data={ this.props.data } screen={ this.state.screen } location={ this.props.location } />)}/>
              { genericPages }
              <Route render={(props) => (<ErrorPage data={ this.props.data }/>)} />
            </Switch>
          </CSSTransition>
        </TransitionGroup>
      </div>
    )
  }
}

export default withRouter(MainView)


// WEBPACK FOOTER //
// ./src/app/MainView.js